/*
 * - Stores paths for the archive service endpoints
 */

const serviceRoot = 'api/requests/';

export const ArchiveEndpoints = {
  // Mutations -------------------------------------------------------------------------------------
  archiveRequest: () => `${serviceRoot}archive`,
  unArchiveRequest: () => `${serviceRoot}unarchive`,
};
